import {z} from 'zod';

export const generalTabFormSchema = z.object({
  name: z.string(),
  branchId: z.string(),
  storageLocationSeparator: z.string().nullish(),
});

export type GeneralTabFormType = z.infer<typeof generalTabFormSchema>;
